// import SockJS from 'sockjs-client'
import stockService from 'common/services/stockService'
import manualsolutionModal from '../views/common/manualsolutionModal.html'
import utils from 'utils'

class mainCtrl {
    constructor($rootScope, $location, $scope, sweetalert, logger, httpRequest, $state, authService, removeSessionService, operationService, $timeout, $uibModal, $http, collectionExportService, messageService) {
        $scope.IS_PROVIDER = IS_PROVIDER
        window.isBwDisk = '' //是否为百望盘
        // 这里代码登陆前会去执行 刷新也会执行
        if (localStorage.eVersion != eVersion) {
            window.location.reload(true)
            console.log('页面刷新了')
            localStorage.eVersion = eVersion
        }
        if (!window.location.origin) {
            window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
        }
        //定时查询授信额度
        let authAmountTimerName
        function authAmountTimer() {
            if ($rootScope.userInfo.user.userType !== 0) {
                ; (function inner() {
                    if (authAmountTimerName) clearTimeout(authAmountTimerName)
                    httpRequest.post_getTax4AuthAmount({ authorizeId: null }).then((res) => {
                        $scope.authAmountObj = res.data.value
                    })
                    authAmountTimerName = setTimeout(function () {
                        clearTimeout(authAmountTimerName)
                        inner()
                    }, 900000)
                })()
            }
        }
        // 构建主菜单
        $scope.navBuilder = function navBuilder() {
            // 从可操作权限中获取 菜单
            operationService.getFunctions().then((menus) => {
                if (menus === undefined) {
                    return
                }
                $rootScope.functionTree = menus
                let menu
                let topMenuIndex = 0
                const { length } = menus
                for (let i = 0; i < length; i += 1) {
                    menu = menus[i]
                    if (menu.defaultUrl) {
                        // 一级菜单高亮
                        const level1State = menu.defaultUrl.split('.')[0]
                        if ($state.current.name.indexOf(level1State) === 0) {
                            topMenuIndex = i
                            break
                        }
                    }
                }
                $rootScope.subNavData = menus[topMenuIndex].childFuncList
                $scope.topMenuIndex = topMenuIndex
            })
        }
        // 获取企业logo
        function getCompanyLogo() {
            httpRequest.get_companyInfo().then((res) => {
                $scope.logo = res.data.value.imageContent
                localStorage.defaultLogo = $scope.logo
                localStorage.initialStatus = res.data.value.initialStatus
                localStorage.deployType = res.data.value.deployType
                $scope.deployType = res.data.value.deployType
            })
        }
        getCompanyLogo()
        $scope.$on('logoChange', () => {
            getCompanyLogo()
        })
        /**
         * 是否有页面权限
         * @return {Boolean} [description]
         */
        function hasPageRight(toStateName) {
            // const pageListStr = localStorage.getItem('page_list')
            // if (!pageListStr) {
            //     return false
            // }
            const pageList = $rootScope.pageList
            if (!pageList || !pageList.length) return
            const { length } = pageList
            for (let i = 0; i < length; i++) {
                if (pageList[i] === toStateName) {
                    return true
                }
            }
            return false
        }
        const removeSessionArr = [
            ['system.permission.role', ['system.permission.role.add'], 'roleListParam'],
            ['system.permission.user', ['system.permission.user.add'], 'userListParam'],
            ['system.settingcenter.templateSetUp', ['system.settingcenter.templateSetUp.add'], 'templateParam'],
            ['input.inputInvoice.collection', false, 'collectionParam'],
            ['input.inputInvoice.management', false, 'managementParam'],
            ['input.certification.originalAccount', false, 'originalParam'],
            ['input.electronImage.contractEntering', false, 'contractEnterParam'],
            ['input.electronImage.contractManagement', false, 'contractManagementParam'],
            ['statistics.outputStatistics.statisticsInvState', false, 'invStateParam'],
            ['statistics.outputStatistics.statisticsOpenedInv', false, 'openedInvParam'],
            ['statistics.outputStatistics.statisticsTaxRate', false, 'taxRateParam'],
            ['statistics.outputStatistics.statisticsSalesRank', false, 'salesParam'],
            ['statistics.inputStatistics.statisticsPurchaseRank', false, 'purchaseParam'],
            ['outputManage.ovat.buyer', ['outputManage.ovat.buyer.add'], 'buyerParam'],
            ['outputManage.FOManage.ovatBill', false, 'ovatBillParam'],
            ['outputManage.FOManage.eleInvoice', ['outputManage.FOManage.eleInvoice.add'], 'eleInvoiceParam'],
            ['outputManage.FOManage.invoice', ['outputManage.FOManage.invoice.add'], 'invoiceParam'],
            ['outputManage.FOManage.redInfo', ['outputManage.FOManage.redInfo.add'], 'redInfoParam'],
            ['outputManage.FOManage.vehicleInvoice', ['outputManage.FOManage.vehicleInvoice.add'], 'vehicleInvoiceParam'],
            ['outputManage.FOManage.rollTypeInvoice', ['outputManage.FOManage.rollTypeInvoice.add'], 'rollTypeParam'],
            ['outputManage.billManage.cancelInvoice', false, 'cancelParam'],
            // ['outputManage.billManage.openedInvoice', false, 'openedInvParam'],
            ['outputManage.ovat.goodsInfo', ['outputManage.ovat.goodsInfo.add'], 'goodsInfoParam'],
            ['outputManage.ovat.goodsInfo', ['outputManage.ovat.goodsInfo.addCar'], 'carCodeParam'],
            ['system.syssetting.org', ['system.syssetting.org.add'], 'orgListParam'],
        ]

        // 路由拦截
        $scope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
            console.log('监听路由不缓存用户信息')
            sessionStorage.setItem('currentRoutAddress', JSON.stringify(toState.name))
            if (toState.name === 'login' || toState.name === 'loginSingle' || !$rootScope.userInfo) {
                websocketDisconnect(client)
                $('.modal-cancel').click()
                return
            }
            authAmountTimer()
            $rootScope.rightless = !hasPageRight(toState.name)
            // 没有销方信息不允许操作销项管理
            function tempForbid(stateName) {
                if (stateName.indexOf('outputManage.FOManage') === 0) {
                    if (stateName.indexOf('add') > 0 || stateName.indexOf('edit') > 0 || stateName.indexOf('detail') > 0 || stateName.indexOf('rollTypeInvoiceAdd') > 0 || stateName.indexOf('VehicleBuleInvAdd') > 0) {
                        return true
                    }
                }
                return false
            }
            if ((!$rootScope.userInfo.sysUkeyList || $rootScope.userInfo.sysUkeyList.length === 0) && tempForbid(toState.name)) {
                event.preventDefault()
                logger.logError('您还没有配置开票点，不能进行该操作')
            }
            if (!$rootScope.userInfo.sale && tempForbid(toState.name)) {
                event.preventDefault()
                logger.logError('该机构未配置纳税人信息，不能进行该操作')
            }
            if (!authService.isloggedIn() && $location.path() != '/belleSsoLogin') {
                console.log('路由拦截')
                $state.go('login')
                logger.logError('请先登录')
                event.preventDefault()
            }
            if (toState.name === 'workspace.item' && fromState.name.split('.').length > 2) {
                const { hash } = window.location
                if (hash.split('/').length == 4) {
                    window.history.go(1)
                }
            }
            let { title } = toState
            // abstract路由标题
            const abstractTitle = $state.get(toState.name.split('.').slice(0, 3).join('.')).title
            if (!title) {
                title = abstractTitle
            }
            if (title === '新增' || title === '编辑' || title === '设置') {
                title += abstractTitle.replace('列表', '').replace('管理', '').replace('录入', '')
            }
            document.title = title
            for (const i in $rootScope.functionTree) {
                if (!!$rootScope.functionTree[i].defaultUrl && $rootScope.functionTree[i].defaultUrl === toState.name) {
                    $rootScope.subNavData = $rootScope.functionTree[i].childFuncList
                    $scope.topMenuIndex = +i
                    if ($rootScope.functionTree[i].functionName != '首页') {
                        $('body').removeClass('leftnav-close')
                        $('.u-collapsedsubnav>i').removeClass('closed icon-shousuo')
                        $('.u-collapsedsubnav>i').addClass('icon-zhankai')
                    }
                    break
                }
            }
            // 不同路由页面跳转清除缓存查询条件
            removeSessionArr.forEach((item) => {
                removeSessionService(toState, fromState, item[0], item[1], item[2])
            })
        })
        $scope.$on('$stateChangeSuccess', (event, toState) => {
            const toStateAbstact = $state.get(toState.name.split('.').slice(0, 3).join('.'))
            if (toStateAbstact) {
                localStorage.setItem('currentStateName', toStateAbstact.default)
            }
        })

        $scope.isCollapsed = false
        // 常用菜单
        $scope.getUserCustomized = function getUserCustomized() {
            httpRequest.get_getUserCustomized(2).then((res) => {
                if (res.data.value) {
                    $scope.customMenuList = JSON.parse(res.data.value)
                }
            })
        }
        /**
         * 常用菜单点击事件处理各级菜单的选中
         * @param  {string} url 常用菜单的url
         */
        $scope.frequentMenuClick = function frequentMenuClick(url) {
            $rootScope.functionTree.forEach((level1, index1) => {
                const level2List = level1.childFuncList
                if (level2List) {
                    level2List.forEach((level2) => {
                        level2.childFuncList.forEach((level3) => {
                            if (level3.url === url) {
                                $scope.topMenuIndex = index1
                                $rootScope.subNavData = level2List
                            }
                        })
                    })
                }
            })
            $state.go(url)
        }
        // 同浏览器登录不同用户员页面刷新
        window.addEventListener(
            'storage',
            (e) => {
                if (e.key === 'id_token' && e.oldValue) {
                    $rootScope.$broadcast('logIn', true)
                }
            },
            false
        )

        // 用户信息改变
        $scope.getUserInfoChanged = function getUserInfoChanged() {
            httpRequest.get_getLoginInfo().then((res) => {
                const userInfo = resetRoleList(res.data.value)
                localStorage.setItem('user_info', JSON.stringify(userInfo))
                $rootScope.userInfo = $.extend($rootScope.userInfo, res.data.value)
            })
        }

        // 用户信息广播
        $scope.$on('userInfoChanged', $scope.getUserInfoChanged)

        // 顶部工作台消息
        $rootScope.userMessage = {}
        // 消息
        $rootScope.userMessage.userNoticeCount = 0
        $rootScope.userMessage.userNoticeList = []
        // 工作台
        $rootScope.userMessage.taskTotalCount = 0
        $rootScope.userMessage.workspaceNoticeList = []

        // 更新当前未读消息
        function updateNoticeCount() {
            httpRequest.post_getNoticeCount().then((res) => {
                const userNoticeListArr = res.data
                const userNoticeLen = userNoticeListArr.length
                let userNoticeTotalCount = 0
                $rootScope.userMessage.userNoticeList = userNoticeListArr
                for (let i = 0; i < userNoticeLen; i++) {
                    userNoticeTotalCount += userNoticeListArr[i].noticeCount
                }
                $rootScope.userMessage.userNoticeCount = userNoticeTotalCount
            })
        }
        // 更新当前认证状态
        function updateCertificationCount() {
            let data = {
                orgIdList: [],
            }
            if ($rootScope.userInfo.user.userType !== 0) {
                httpRequest.post_realNameAuthStatCount(data).then((res) => {
                    $rootScope.userMessage.certificationCount = res.data.value.notAuthed + res.data.value.notLogged
                })
            }
        }
        $rootScope.$on('certificationStatusChange', () => {
            updateCertificationCount()
        })
        $rootScope.$on('messageStatusChange', updateNoticeCount)

        function updateRunTask() {
            httpRequest.get_getRunTaskCount().then((res) => {
                const workspaceNoticeListArr = res.data.value
                const workspaceNoticeLen = workspaceNoticeListArr.length
                let taskTotalCount = 0

                if (res.data.success && workspaceNoticeLen > 0) {
                    $rootScope.userMessage.workspaceNoticeList = res.data.value
                    for (let i = 0; i < workspaceNoticeLen; i++) {
                        taskTotalCount += workspaceNoticeListArr[i].taskCount
                    }
                    $rootScope.userMessage.taskTotalCount = taskTotalCount
                }
            })
        }
        // websocket
        let client
        let wsTimer
        // sock客户端对象
        const websocketConnect = function websocketConnect(userName) {
            const _path = `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host === 'localhost:3000' ? '192.168.51.193' : location.host}/socket/websocket`
            const ws = new WebSocket(_path)
            ws.onopen = function () {
                console.log(_path)
                ws.send(`${userName}workflowNotice`)
                ws.send(`${userName}messageCenterNotice`)
                wsTimer = setInterval(() => {
                    ws.send('heartbeat')
                }, 30000)
            }
            ws.onmessage = function (e) {
                console.log('工作台待办消息广播成功', e)
                if (JSON.parse(e.data).sid == `${userName}workflowNotice`) updateRunTask(true)
                if (JSON.parse(e.data).sid == `${userName}messageCenterNotice`) updateNoticeCount()
            }
            ws.onclose = function (e) {
                console.log('工作台待办消息socket关闭', e)
            }
            return ws
        }
        // sock断开连接
        const websocketDisconnect = function websocketDisconnect(client) {
            if (client) {
                client.close()
                clearInterval(wsTimer)
            }
        }

        // 订阅事件,从home.admin 进来
        $scope.$on('enterSystem', () => {
            messageService.openShowList()
        })
        $scope.sysInit = function sysInit(event, isLogin) {
            $scope.customMenuList = null
            $scope.soapTips = '本地组件环境检测中'
            clearInterval(timer)
            soapPortCount = 0
            totalCount = 0
            openSoapTime = 0
            window.layer.closeAll() //关闭原来的 系统消息提示
            $scope.topMenuIndex = 0
            // 初始化所需要的全局数据
            // 检查用户是否登陆
            const userInfo = localStorage.getItem('user_info')
            if (($state.current.name == 'loginSingle' || $location.path() == '/belleSsoLogin') && !userInfo) {
                // websocketDisconnect(client)
                console.log('$state.current.name == loginSingle')
                return
            }
            if (!authService.isloggedIn() || !userInfo) {
                $state.go('login')
                return
            }
            $rootScope.userInfo = JSON.parse(userInfo)
            // 权限请求
            const r = operationService.init()
            if (!r || r.length === 0) {
                logger.logError('您还没有任何操作权限，请先联系管理员添加权限')
                return
            }
            $timeout(() => {
                $scope.navBuilder()
            })
            // 获取token
            $rootScope.idToken = authService.getTokens()
            // if (!IS_PROVIDER) {
            // 获取常用菜单
            $scope.getUserCustomized()
            // 字典数组
            $scope.dictData = {}
            const typecodeArrStr = '["notice_type_a","manage_type","tax_disk_connect","disk_device_type"]'
            httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
                $scope.dictData = Object.assign($scope.dictData, res.data.value)
                // 进项设备类型
                inputDeviceType()
                // 我的消息
                updateNoticeCount()
                // 实名认证
                updateCertificationCount()
            })

            // NOTE: 顶部菜单消息中心
            messageService.fetchMessageCenter()

            // NOTE: 查询需要显示的弹窗消息
            // 需要放到index模块中去
            window.onload = () => {
                if (
                    //$state.current.name !== 'home.admin' &&
                    $state.current.name !== 'login' &&
                    $state.current.name !== 'license'
                ) {
                    messageService.openShowList()
                }
            }
            // 我的工作台
            updateRunTask()
            // }
            if (isLogin) {
                const { user } = $rootScope.userInfo
                // 1 判断用户是否第一次登陆
                if (user.isFistLogin === 1) {
                    // if (IS_PROVIDER) {
                    //     $rootScope.userInfo.custOrgId = -999
                    //     $state.go('help.initChangePW')
                    // } else {
                    $state.go('initStep.initStepOne')
                    // }
                    // 根据用户类型决定跳转
                    // } else if (user.userType === 0) {
                    //     // 跳转到 home.admin 由该模块决定重定向到用户所在页面
                    //     // this.removeSessionService.path("/home/admin").replace();
                    //     $state.go('home.admin')
                } else if (localStorage.initialStatus == 0 && localStorage.deployType == 2) {
                    $state.go('license')
                } else if (r[0].defaultUrl) {
                    $state.go(r[0].defaultUrl)
                    messageService.openShowList()
                } else {
                    $state.go(r[0].url)
                    messageService.openShowList()
                }
            }
        }
        // 打印助手 ws://127.0.0.1:8999
        let printHelperConnect = function () {
            const _path = `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.protocol === 'https:' ? 'soap.szhtxx.com:8999' : '127.0.0.1:8999'}`
            let ws = new WebSocket(_path)
            let param = {
                printerlist: [],
                printHelperIsConnect: false,
            }
            ws.onopen = function () {
                ws.send('getprinterlist')
            }
            ws.onerror = function (evt) {
                param.printHelperIsConnect = false
                localStorage.setItem('printHelperParam', JSON.stringify(param))
            }

            ws.onmessage = function (evt) {
                param.printerlist = JSON.parse(evt.data)
                param.printHelperIsConnect = true
                localStorage.setItem('printHelperParam', JSON.stringify(param))
                ws.close()
            }
        }
        // 进项设备类型
        async function inputDeviceType() {
            let inputSettingDeviceType
            $scope.deviceTypeList = $scope.dictData['disk_device_type'].concat().splice(0, 2)

            let res = await httpRequest.get_checkCollectConfigure()
            inputSettingDeviceType = res.data && res.data.deviceType
            $scope.hasBothdevice = res.data && res.data.deviceType === '3'

            httpRequest.get_getUserCustomized(138).then((result) => {
                if (result.data.value) {
                    $scope.deviceType = $scope.hasBothdevice ? JSON.parse(result.data.value).deviceType || '1' : inputSettingDeviceType
                    $scope.deviceTypeName = $scope.deviceType && $scope.dictData['disk_device_type'][+$scope.deviceType - 1]['enumName']
                    localStorage.setItem(
                        'inputDeviceType',
                        JSON.stringify({
                            deviceType: $scope.deviceType,
                            deviceTypeName: $scope.deviceTypeName,
                        })
                    )
                    $scope.defaultSoapPort = JSON.parse(result.data.value).defaultSoapPort
                }
                // 建立ws
                if ($rootScope.userInfo.user.userType !== 0) {
                    client = websocketConnect($rootScope.userInfo.user.userName)
                    printHelperConnect()
                    checkSoap()
                    // NOTE: 自动上报和自动清卡操作
                    collectionExportService.exportAuto()
                }
            })
        }

        $scope.deviceTypeBtn = function () {
            $scope.deviceTypeException = !$scope.deviceTypeException
        }
        $scope.deviceTypeChange = function (deviceType) {
            if (deviceType && $scope.deviceType === deviceType) {
                return
            }

            httpRequest
                .post_saveUserCustomized({
                    profileInfo: JSON.stringify({
                        deviceType,
                        deviceTypeName: $scope.dictData['disk_device_type'][+deviceType - 1]['enumName'],
                        defaultSoapPort: $scope.defaultSoapPort,
                    }),
                    profileType: '138',
                })
                .then(() => {
                    logger.logSuccess('切换成功')
                    $scope.deviceType = deviceType
                    $scope.deviceTypeName = $scope.dictData['disk_device_type'][+$scope.deviceType - 1]['enumName']
                    localStorage.setItem(
                        'inputDeviceType',
                        JSON.stringify({
                            deviceType: $scope.deviceType,
                            deviceTypeName: $scope.deviceTypeName,
                        })
                    )
                })
                .finally(() => {
                    $scope.topbarNav1 = false
                    $scope.deviceTypeException = false
                })
        }
        $scope.sysInit()
        // 登陆广播
        $rootScope.$on('logIn', $scope.sysInit)
        // 常用菜单广播
        $rootScope.$on('getUserCustomizedChanged', $scope.getUserCustomized)
        // 进项设备类型
        $rootScope.$on('inputDevice', inputDeviceType)
        // 工具条操作逻辑
        // 多个dropdown出现了无法操作切换操作机构选项，临时处理一下
        $scope.topbarNav1 = false
        $scope.topbarNav1Exception = false
        $scope.deviceTypeException = false
        $scope.topbarNav2 = false
        $scope.topbarNav3 = false
        $scope.topbarNav4 = false
        $scope.showUserInfoMenu = function ($event, v) {
            $event.preventDefault()
            $event.stopPropagation()
            $('.j-hasmenu').removeClass('z-crt')
            $($event.currentTarget).addClass('z-crt')
            $scope[v] = true
            if (v === 'topbarNav3') {
                updateNoticeCount()
                messageService.fetchMessageCenter()
            }
            if (v === 'topbarNav4') {
                updateRunTask()
            }
            $scope.shortObj = {}
            $scope.shortObj.selectCurrentOrgName = $scope.userInfo.org.orgName
            const orgList = $rootScope.loginOrgList

            $scope.shortObj.list = orgList
            $scope.selectCurrentOrgId = $scope.userInfo.user.currentOrgId
        }
        $scope.hideUserInfoMenu = function ($event, v) {
            $event.preventDefault()
            $event.stopPropagation()
            $('.j-hasmenu').removeClass('z-crt')
            $scope[v] = false
            $scope.topbarNav1Exception = false
            $scope.deviceTypeException = false
        }
        // 自动高度
        $scope.autoHeightConfig = {
            headerHeight: 60,
            footerHeight: 0,
        }

        // 顶部导航切换按钮
        $scope.toggleLeftNavClose = function (event) {
            if ($('.navbar-left a.active').text() === '首页' || $rootScope.leftNavDisabled === true) return
            const $closeEle = $(event.target)
            if ($closeEle.hasClass('closed')) {
                $('body').removeClass('leftnav-close')
                $closeEle.removeClass('closed icon-shousuo')
                $closeEle.addClass('icon-zhankai')
            } else {
                $('body').addClass('leftnav-close')
                $closeEle.addClass('closed icon-shousuo')
                $closeEle.removeClass('icon-zhankai')
            }
        }

        // 监听切换机构广播

        $rootScope.$on('permissionsChanged', () => {
            // 清除所有缓存
            localStorage.removeItem('user_info')
            localStorage.removeItem('fullEleInvoice61')
            localStorage.removeItem('fullEleInvoice62')
            localStorage.removeItem('openedFullEleInvoice')
            localStorage.removeItem('openedFullEleInvoice61')
            localStorage.removeItem('openedFullEleInvoice62')
            operationService.destroy()
            sessionStorage.clear()
            httpRequest.get_getLoginInfo().then((res) => {
                const userInfo = resetRoleList(res.data.value)
                localStorage.setItem('user_info', JSON.stringify(userInfo))
                $rootScope.userInfo = res.data.value
                // this.$rootScope.userInfo = userInfo;
                checkIsSoapWarn()
                // 常用菜单重新请求
                $scope.getUserCustomized()
                // 根据用户类型决定跳转
                httpRequest.get_getFunctionListByUser().then((res1) => {
                    localStorage.setItem('function_list', JSON.stringify(res1.data.value))
                    const r = operationService.init()
                    // if (userInfo.userType === 0) {
                    //     // 跳转到 home.admin 由该模块决定重定向到用户所在页面
                    //     // this.removeSessionService.path("/home/admin").replace();
                    //     $state.go('home.admin', {}, {
                    //         reload: true,
                    //     })
                    // } else {
                    // 跳转到 home.user 由该模块决定用户显示哪些菜单
                    // this.removeSessionService.path("/home/user").replace();
                    // dev1.1优化需求，普通用户隐藏首页 @auth sujingjun
                    // $state.go('home.user')
                    if (!r) {
                        logger.logError('该机构没有任何操作权限，请先联系管理员添加权限')
                        $state.go(
                            'login',
                            {},
                            {
                                reload: true,
                            }
                        )
                    } else {
                        // window.location.reload()
                        const r = operationService.init()
                        if (r[0].defaultUrl) {
                            $state.go(
                                r[0].defaultUrl,
                                {},
                                {
                                    reload: true,
                                }
                            )
                        } else {
                            $state.go(
                                r[0].url,
                                {},
                                {
                                    reload: true,
                                }
                            )
                        }
                    }
                })
            })
        })
        // 由于部分用户返回的RoleList太大缓存不了 改缓存在顶层的作用域
        function resetRoleList(userInfo) {
            const roleIdList = userInfo.user.roleIdList
            const roleList = userInfo.user.roleList
            $rootScope.userRoleIdList = roleIdList
            $rootScope.userRoleList = roleList
            $rootScope.loginOrgList = userInfo.orgList //放顶层作用域,先不缓存
            userInfo.user.roleIdList = []
            userInfo.user.roleList = []
            userInfo.orgList = []
            return userInfo
        }
        // 切换操作机构选项
        $scope.currentOrgIdChange = function (orgId) {
            // 优化 机构会存在为0的机构不能切换
            if (!orgId && orgId != 0) {
                return
            }
            if (orgId && $scope.userInfo.user.currentOrgId === orgId) {
                return
            }
            $scope.userInfo.user.currentOrgId = orgId == 0 ? 0 : orgId || $scope.userInfo.custOrgId
            httpRequest.get_changeOrg($scope.userInfo.user.currentOrgId, '切换成功').then(() => {
                $scope.topbarNav1 = false
                $scope.topbarNav1Exception = false
                // 权限控制
                $rootScope.$broadcast('permissionsChanged')
            })
        }

        // 普通用户进入系统按钮
        $scope.goNormalUserRouter = function () {
            $state.go($rootScope.functionTree[0].defaultUrl)
        }

        $scope.loginOut = function () {
            $('body').removeClass('leftnav-close')
            authService.logout()
            websocketDisconnect(client)
            // httpRequest.get_loginOut('',"用户登出成功").then(res =>  {
            //  $state.go('login');
            // });
        }
        // 顶部菜单点击
        $scope.topNavClick = function (item, index) {
            $rootScope.leftNavDisabled = false
            // $rootScope.subNavData = item.childFuncList
            // 目前走请求又被初始化了
            if (item.defaultUrl !== undefined && item.childFuncList && item.childFuncList.length) {
                item.childFuncList.forEach((o) => {
                    if (item.defaultUrl.indexOf(o.url) != -1 && o.childFuncList && o.childFuncList.length) {
                        o.childFuncList.forEach((ele) => {
                            if (item.defaultUrl === ele.url) {
                                localStorage.setItem('defaultKey', ele.functionId)
                                localStorage.setItem('defaultName', ele.functionName)
                            }
                        })
                    }
                })
                $state.go(item.defaultUrl)
            } else {
                $state.go(item.url)
            }
            // $scope.topMenuIndex = index
        }

        // $scope.mainCtrl = {};
        $scope.subNavClick = function (item) {
            // if (isBwDisk == 1 && item.url.indexOf('stock')>0) {
            //     logger.logTips('抱歉！该功能暂时不支持使用百望税控盘', 'warn')
            //     return
            // }
            // 改变当前页面选中项
            const _treeLevelCode = item.treeLevelCode
            const { url } = item
            $rootScope.functionTree = $rootScope.functionTree.map((obj, index) => {
                // 进项管理 0_3开头，统计报表0_360开头，统计报表匹配时，进项管理也会匹配，所以增加_，比如以0_3_开头进行匹配避免错误匹配
                const _pattern = new RegExp(`^${obj.treeLevelCode}_`)
                if (obj.defaultUrl !== undefined && _pattern.test(_treeLevelCode)) {
                    obj.defaultUrl = url
                }
                return $.extend({}, obj)
            })
            $scope.subNavIndex = item.functionId
            //localStorage.setItem('function_tree', JSON.stringify($rootScope.functionTree))
            localStorage.setItem('defaultKey', item.functionId)
            localStorage.setItem('defaultName', item.functionName)
            $state.go(url, {
                obj: item.functionId,
            })
            // 页面的按钮的权限控制位
            // 这种方式已经停用 改用命中整张权限表的方式来控制
            // $scope.mainCtrl.pagePermit = item.childFuncList;
        }

        // 操作指引
        $scope.openProviderHelp = function openProviderHelp() {
            $state.go('help.list')
        }
        let response
        let soapPortCount = 0
        let totalCount = 0
        // 检测是否安装soap，以及soap是否打开
        function checkSoap() {
            if (!localStorage.id_token) return
            if (totalCount >= 9) return ($scope.soapTips = '服务启动失败，请联系航信运维！')
            $scope.defaultSoapPort || ($scope.defaultSoapPort = '8888')
            if (soapPortCount >= 3) {
                switch ($scope.defaultSoapPort) {
                    case '8888':
                        $scope.defaultSoapPort = '9117'
                        soapPortCount = 0
                        break
                    case '9117':
                        $scope.defaultSoapPort = '8916'
                        soapPortCount = 0
                        break
                    case '8916':
                        $scope.defaultSoapPort = '8888'
                        soapPortCount = 0
                        break
                    default:
                        $scope.defaultSoapPort = '8888'
                        soapPortCount = 0
                        break
                }
            }
            const soapStorage = localStorage.soap && JSON.parse(localStorage.soap)
            const timer = new Date().getTime()
            if (soapStorage && timer - soapStorage.timer < 10000) {
                $scope.soapStatus = soapStorage.status
                response = soapStorage.response
                setTimeout(() => {
                    checkSoap()
                }, 1000)
                return
            }
            let _url = REAL_URL.replace('8888', $scope.defaultSoapPort)
            if (fullEleStopCheckSoap()) {
                $.post({
                    url: _url,
                    data: {
                        SID: '1106',
                        SIDParam: '',
                    },
                    timeout: 30000,
                }).then(
                    (data) => {
                        soapPortCount = 0
                        totalCount = 0
                        localStorage.soapPort = $scope.defaultSoapPort
                        httpRequest.post_saveUserCustomized({
                            profileInfo: JSON.stringify({
                                deviceType: $scope.deviceType,
                                deviceTypeName: $scope.deviceTypeName,
                                defaultSoapPort: $scope.defaultSoapPort,
                            }),
                            profileType: '138',
                        })
                        const DECMSG = JSON.parse(data).ENCMSG.replace(new RegExp('[_]', 'gm'), '+').replace(new RegExp(/(\r)/g), '').replace(new RegExp(/(\n)/g), '')
                        httpRequest
                            .post_base64DeCode({
                                invData: DECMSG,
                                codeType: 'decode',
                            })
                            .then((res) => {
                                const resInfo = JSON.parse(res.data.value)
                                // localStorage.currentDiskCode = ''
                                // $scope.currentDiskCode = ''
                                if (resInfo.retcode == 1) {
                                    if (resInfo.openFlag == -1) {
                                        console.log('soap状态繁忙')
                                        $scope.soapStatus = $scope.soapStatus || 3
                                    } else if (resInfo.openFlag == 0) {
                                        $scope.soapStatus = 1
                                        localStorage.currentDiskCode = ''
                                        $scope.currentDiskCode = ''
                                    } else if (resInfo.openFlag == 4 || resInfo.openFlag == 5) {
                                        $scope.soapStatus = 3
                                        checkIsSoapWarn()
                                    } else {
                                        $scope.soapStatus = 2
                                        localStorage.currentDiskCode = ''
                                        $scope.currentDiskCode = ''
                                    }
                                } else {
                                    $scope.soapStatus = 1
                                    localStorage.currentDiskCode = ''
                                    $scope.currentDiskCode = ''
                                }
                                const reqList = response ? response.regDJ : []

                                mapTaxList(reqList).then((result) => {
                                    $scope.taxInfoList = result.diskList
                                    $scope.hasAgent = false
                                    result.diskList.forEach((item) => {
                                        if (item.diskConnectStatus == 1 && item.taxcode == $scope.userInfo.sale.saleCreditCode) $scope.hasAgent = true
                                    })
                                    localStorage.soap = JSON.stringify({
                                        status: $scope.soapStatus,
                                        response,
                                        timer: new Date().getTime(),
                                        taxInfoList: result,
                                    })
                                })
                                setTimeout(() => {
                                    console.log(`output->`, fullEleStopCheckSoap())
                                    checkSoap()
                                }, 10000)
                            })
                    },
                    () => {
                        soapPortCount++
                        totalCount++
                        $timeout(() => {
                            $scope.soapStatus = 1
                        })
                        mapTaxList([]).then((result) => {
                            $scope.taxInfoList = result.diskList
                            $scope.hasAgent = false
                            result.diskList.forEach((item) => {
                                if (item.diskConnectStatus == 1 && item.taxcode == $scope.userInfo.sale.saleCreditCode) $scope.hasAgent = true
                            })
                            localStorage.soap = JSON.stringify({
                                status: $scope.soapStatus,
                                response,
                                timer: new Date().getTime(),
                                taxInfoList: result,
                            })
                        })
                        setTimeout(() => {
                            checkSoap()
                        }, 10000)
                    }
                )
            } else {
                setTimeout(() => {
                    console.log(`output->`, fullEleStopCheckSoap())
                    checkSoap()
                }, 10000)
            }
        }
        // $scope.$watch('soapStatus', () => {
        //     checkIsSoapWarn()
        // })
        // 全电模块不调soap
        function fullEleStopCheckSoap() {
            const { $$url } = $location
            const regex = /\/(ovat|basedata)\/([^/]+)/
            const match = $$url.match(regex)
            let allElectricModule = null
            if (match) {
                allElectricModule = match[2]
            }
            switch (true) {
                case allElectricModule === 'openedFullEleInvoice':
                    return false
                case allElectricModule === 'fullEleInvoice':
                    return false
                case allElectricModule === 'drawer':
                    return false
                case allElectricModule === 'redInkConfirmForm':
                    return false
                case allElectricModule === 'fullEleInvoiceIsAbnormal':
                    return false
                case allElectricModule === 'taxAccount':
                    return false
                default:
                    return true
            }
        }
        function checkIsSoapWarn() {
            if ($scope.soapStatus == 3) {
                useSoap('1103').then((res) => {
                    response = res
                    if (response.retcode === '1') {
                        if (!response.djTaxcode || !response.djMachineNO) {
                            stockService.getDiskInfo().then(
                                (diskInfo) => {
                                    response.djTaxcode = JSON.parse(diskInfo).TaxCode
                                    response.djMachineNO = `${JSON.parse(diskInfo).MachineNo}`
                                    $scope.isSoapWarn = true
                                    localStorage.currentDiskCode = ''
                                    $scope.currentDiskCode = ''
                                    if ($rootScope.userInfo.sale && response.djTaxcode == $rootScope.userInfo.sale.saleCreditCode) {
                                        $rootScope.userInfo.sysUkeyList.forEach((item) => {
                                            if (item.diskCode == response.djMachineNO && item.manageType != 2) {
                                                $timeout(() => {
                                                    $scope.isSoapWarn = false
                                                    $scope.currentDiskCode = item.ukeyName
                                                    localStorage.currentDiskCode = response.djMachineNO
                                                })
                                            }
                                        })
                                    }
                                },
                                (err) => {
                                    logger.logError(err)
                                }
                            )
                        } else if ($rootScope.userInfo.sale && response.djTaxcode == $rootScope.userInfo.sale.saleCreditCode) {
                            $scope.isSoapWarn = true
                            localStorage.currentDiskCode = ''
                            $scope.currentDiskCode = ''
                            $rootScope.userInfo.sysUkeyList.forEach((item) => {
                                if (item.diskCode == response.djMachineNO && item.manageType != 2) {
                                    $timeout(() => {
                                        $scope.isSoapWarn = false
                                        $scope.currentDiskCode = item.ukeyName
                                        localStorage.currentDiskCode = response.djMachineNO
                                    })
                                }
                            })
                        } else {
                            $scope.isSoapWarn = true
                            localStorage.currentDiskCode = ''
                            $scope.currentDiskCode = ''
                        }
                    }
                })
            } else {
                localStorage.currentDiskCode = ''
                $scope.currentDiskCode = ''
            }
        }
        // 返回接入soap信息
        function useSoap(SID) {
            let _url = REAL_URL.replace('8888', localStorage.soapPort)
            return new Promise((resolve, rejects) => {
                $.post({
                    url: _url,
                    data: {
                        SID,
                        SIDParam: '',
                    },
                    timeout: 30000,
                }).then(
                    (data) => {
                        const DECMSG = JSON.parse(data).ENCMSG.replace(new RegExp('[_]', 'gm'), '+').replace(new RegExp(/(\r)/g), '').replace(new RegExp(/(\n)/g), '')
                        httpRequest
                            .post_base64DeCode({
                                invData: DECMSG,
                                codeType: 'decode',
                            })
                            .then((res) => {
                                resolve(JSON.parse(res.data.value))
                            })
                    },
                    () => {
                        rejects()
                    }
                )
            })
        }

        // 启动服务、切盘
        function checkDisk(taxCode, diskCode) {
            let _url = REAL_URL.replace('8888', localStorage.soapPort)
            return new Promise((resolve, rejects) => {
                httpRequest
                    .post_base64DeCode({
                        invData: JSON.stringify({
                            taxcode: taxCode,
                            machineNO: diskCode,
                            terminalNO: '',
                            diskType: 0,
                        }),
                        codeType: 'encode',
                    })
                    .then((res) => {
                        $.post({
                            url: _url,
                            data: {
                                SID: '1104',
                                SIDParam: res.data.value,
                            },
                            timeout: 180000,
                        }).then(
                            (data) => {
                                const DECMSG = JSON.parse(data).ENCMSG.replace(new RegExp('[_]', 'gm'), '+').replace(new RegExp(/(\r)/g), '').replace(new RegExp(/(\n)/g), '')
                                httpRequest
                                    .post_base64DeCode({
                                        invData: DECMSG,
                                        codeType: 'decode',
                                    })
                                    .then((res) => {
                                        if (JSON.parse(res.data.value).retcode === '1') {
                                            resolve()
                                        } else {
                                            rejects(JSON.parse(res.data.value).retmsg)
                                        }
                                    })
                            },
                            () => {
                                rejects()
                            }
                        )
                    })
            })
        }

        //
        function mapTaxList(list) {
            list || (list = [])
            return new Promise((resolve) => {
                let diskList = []
                const resList = []
                $http.post(`${host.etcloud}ems/sysUkey/fixDiskCodeName`, list).then((res) => {
                    diskList = res.data.value
                    const obj = {}
                    diskList.forEach((item) => {
                        if (!obj[item.taxcode]) {
                            obj[item.taxcode] = [item.machineNO]
                        } else {
                            obj[item.taxcode].push(item.machineNO)
                        }
                    })
                    for (const i in obj) {
                        resList.push({
                            taxCode: i,
                            arr: obj[i],
                        })
                    }
                    resolve({
                        resList,
                        diskList,
                    })
                })
            })
        }
        $scope.soapStatus = 1
        // 安装soap
        $scope.installSoap = function installSoap() {
            sweetalert.confirm('操作提醒', '系统检测到未安装控制台依赖组件，请下载安装').then(() => {
                httpRequest.get_getSoftwareVersion().then((res) => {
                    window.open(res.data.value.software.install_url)
                })
            })
        }
        // 启动soap
        $scope.startSoap = function startSoap() {
            sweetalert.confirm('操作提醒', '未开启金税盘服务，请开启服务').then(() => {
                let opening = window.layer.msg('开启中...', {
                    time: 0,
                    skin: 'layer-loading-self',
                    icon: 16,
                    shade: 0.5,
                })
                useSoap('1107').then(
                    (res) => {
                        if (res.retcode == 1) {
                            if (!res.regCode || !res.regCode.listSubRegTaxcode || !res.regCode.listSubRegTaxcode.length) {
                                window.layer.close(opening)
                                logger.logError('未识别到税号，请检查税号是否注册')
                            } else if (res.regCode && res.regCode.listSubRegTaxcode && res.regCode.listSubRegTaxcode.length > 1) {
                                window.layer.close(opening)
                                $uibModal
                                    .open({
                                        templateUrl: 'startSoap.html',
                                        openedClass: 'mod-modal mod-modal-md',
                                        controller: [
                                            '$scope',
                                            '$uibModalInstance',
                                            '$timeout',
                                            'diskConfig',
                                            function ($scope, $uibModalInstance, $timeout, diskConfig) {
                                                $scope.taxCode = diskConfig.defualtTaxcode
                                                $scope.diskCode = diskConfig.defaultMachineNO
                                                mapTaxList(diskConfig.listSubRegTaxcode).then((res) => {
                                                    $timeout(() => {
                                                        $scope.taxCodeList = res.resList
                                                        $scope.diskList = res.diskList
                                                        $scope.diskInfoChange()
                                                    })
                                                })

                                                $scope.diskInfoChange = function diskInfoChange(v) {
                                                    $scope.taxCodeList.forEach((o) => {
                                                        if (o.taxCode == $scope.taxCode) $scope.diskCodeList = o.arr
                                                    })
                                                    if ($scope.taxCode == diskConfig.defualtTaxcode && v) {
                                                        $scope.diskCode = diskConfig.defaultMachineNO
                                                    } else if (v) {
                                                        $scope.diskCode = $scope.diskCodeList[0]
                                                    }
                                                    const disk = $scope.diskList.filter((item) => item.machineNO == $scope.diskCode && item.taxcode == $scope.taxCode)
                                                    $scope.diskName = disk[0] && disk[0].diskName
                                                }
                                                $scope.ok = function () {
                                                    $uibModalInstance.close({
                                                        taxCode: $scope.taxCode,
                                                        diskCode: $scope.diskCode,
                                                    })
                                                }
                                                $scope.cancel = function () {
                                                    $uibModalInstance.dismiss('cancel')
                                                }
                                            },
                                        ],
                                        animation: true,
                                        resolve: {
                                            diskConfig() {
                                                return res.regCode
                                            },
                                        },
                                    })
                                    .result.then((obj) => {
                                        openSoapModal(obj)
                                    })
                            } else {
                                mapTaxList(res.regCode.listSubRegTaxcode).then((list) => {
                                    if (!list.diskList || !list.diskList[0].diskName) {
                                        window.layer.close(opening)
                                        logger.logError('未维护开票点信息或未授权')
                                    } else {
                                        let hasSameDisk = false
                                        $scope.userInfo.sysUkeyList.forEach((item) => {
                                            if (item.diskCode == res.regCode.defaultMachineNO) {
                                                hasSameDisk = true
                                            }
                                        })
                                        if (hasSameDisk) {
                                            window.layer.close(opening)
                                            openSoapModal({
                                                taxCode: res.regCode.defualtTaxcode,
                                                diskCode: res.regCode.defaultMachineNO,
                                            })
                                        } else {
                                            window.layer.close(opening)
                                            logger.logError('未维护开票点信息或未授权')
                                        }
                                    }
                                })
                            }
                        } else {
                            logger.logError('获取当前注册表中金税盘信息失败')
                        }
                    },
                    () => {
                        logger.logError('开票服务器启动超时，请退出后重试！')
                        window.layer.close(opening)
                    }
                )
            })
        }
        // 已启动之后才注册切盘事件
        $scope.changeDisk = function changeDisk() {
            $uibModal
                .open({
                    templateUrl: 'changeDisk.html',
                    openedClass: 'mod-modal mod-modal-lg',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        '$timeout',
                        'diskConfig',
                        function ($scope, $uibModalInstance, $timeout, diskConfig) {
                            $scope.taxCodeList = []
                            $scope.taxCode = diskConfig.response.djTaxcode
                            $scope.diskCode = diskConfig.response.djMachineNO
                            mapTaxList(diskConfig.response.regDJ).then((res) => {
                                $timeout(() => {
                                    $scope.taxCodeList = res.resList
                                    $scope.diskList = res.diskList
                                    $scope.taxCodeList.forEach((o) => {
                                        if (o.taxCode == $scope.taxCode) $scope.diskCodeList = o.arr
                                    })
                                    checkTaxCodeAndDisk()
                                })
                            })

                            function checkTaxCodeAndDisk(v) {
                                $scope.isSameDisk = false
                                $scope.taxCodeList.forEach((o) => {
                                    if (o.taxCode == $scope.taxCode) $scope.diskCodeList = o.arr
                                })
                                if ($scope.taxCode == diskConfig.response.djTaxcode && v) {
                                    $scope.diskCode = diskConfig.response.djMachineNO
                                } else if (v) {
                                    $scope.diskCode = $scope.diskCodeList[0]
                                }
                                if ($scope.taxCode == $scope.userInfo.sale.saleCreditCode) {
                                    $scope.userInfo.sysUkeyList.forEach((item) => {
                                        if (item.diskCode == $scope.diskCode) $scope.isSameDisk = true
                                    })
                                }
                                const disk = $scope.diskList.filter((item) => item.machineNO == $scope.diskCode && item.taxcode == $scope.taxCode)
                                $scope.diskName = disk[0] && disk[0].diskName
                            }
                            $scope.diskInfoChange = function diskInfoChange(v) {
                                checkTaxCodeAndDisk(v)
                            }
                            $scope.ok = function () {
                                if (!$scope.isSameDisk) {
                                    return
                                }
                                $uibModalInstance.close({
                                    taxCode: $scope.taxCode,
                                    diskCode: $scope.diskCode,
                                })
                            }
                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel')
                            }
                        },
                    ],
                    animation: true,
                    resolve: {
                        diskConfig() {
                            return {
                                response,
                                userInfo: $rootScope.userInfo,
                            }
                        },
                    },
                })
                .result.then((obj) => {
                    openSoapModal(obj)
                })
        }

        function checkSoapBeforeTaxCore() {
            if ($scope.soapStatus == 1) {
                $scope.installSoap()
                return true
            }
            if ($scope.soapStatus == 2) {
                $scope.startSoap()
                return true
            }
            if ($scope.soapStatus == 3) {
                return false
            }
        }
        $scope.$watch('soapStatus', () => {
            $rootScope.soapStatus = $scope.soapStatus
        })
        $scope.connectDisk = function connectDisk() {
            if (openSoapTime) {
                openSoapModal()
            } else if ($scope.soapStatus == 2) {
                $scope.startSoap()
            } else {
                $scope.changeDisk()
            }
        }
        let openSoapTime = 0
        let timer = null

        function openSoapModal(obj) {
            $uibModal
                .open({
                    template: `<div class="modal-body form-horizontal change-disk-modal">
                <h5>开票相关程序启动中，请勿关闭或重启程序，请耐心等待...</h5>
                <p><span class="timer-soap"></span></p>
                <button class="btn btn-lg f-fr btn-primary btn-soap" ng-click="close()">{{text}}</button>
            </div>`,
                    openedClass: 'mod-modal mod-modal-lg modal-soap-modal',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'logger',
                        ($scope, $uibModalInstance, logger) => {
                            $scope.text = '先去干点别的'
                            openSoapTime ||
                                checkDisk(obj.taxCode, obj.diskCode).then(
                                    () => {
                                        useSoap('12').then(
                                            (res) => {
                                                if (res.retcode == '1011') {
                                                    logger.logSuccess('启动成功')
                                                    endFun()
                                                } else {
                                                    logger.logError('开票相关程序启动失败或超时，请重新尝试！')
                                                    endFun()
                                                }
                                            },
                                            () => {
                                                logger.logError('开票相关程序启动失败或超时，请重新尝试！')
                                                endFun()
                                            }
                                        )
                                    },
                                    () => {
                                        logger.logError('开票相关程序启动失败或超时，请重新尝试！')
                                        endFun()
                                    }
                                )
                            timer = setInterval(() => {
                                let widthStr = `${(500 * ++openSoapTime) / 180}px`
                                $('.modal-soap-modal span.timer-soap').css('width', widthStr)
                                if (openSoapTime == 179) {
                                    clearInterval(timer)
                                }
                            }, 1000)

                            function endFun() {
                                clearInterval(timer)
                                openSoapTime = 0
                                $('.modal-soap-modal .btn-soap').click()
                                // $('.modal-soap-modal span.timer-soap').css({
                                //     'width': '500px',
                                //     'background': 'red'
                                // })
                                // $('.modal-soap-modal .btn').text('关闭')
                                console.log('end')
                            }
                            $scope.close = function () {
                                $uibModalInstance.close(123)
                                clearInterval(timer)
                            }
                        },
                    ],
                    animation: true,
                })
                .result.then(() => { })
        }
        $scope.selectOpenHandle = function (e) {
            e = e || window.event
            $scope.stopPropHandle(e)
            $scope.topbarNav1Exception = !$scope.topbarNav1Exception
            if ($scope.topbarNav1Exception) {
                $scope.shortObj.selectCurrentOrgName = ''
                const orgList = $rootScope.loginOrgList

                $scope.shortObj.list = orgList
            }
        }
        //阻止冒泡
        $scope.stopPropHandle = function (e) {
            e = e || window.event
            if (e.stopPropagation) {
                e.stopPropagation()
            } else {
                e.cancelBubble = true
            }
        }
        //机构搜索
        $scope.selectSearch = function() {
            const { selectCurrentOrgName } = $scope.shortObj;
            const orgList = $rootScope.loginOrgList;

            // 无搜索条件时返回完整列表
            if (!selectCurrentOrgName) {
                $scope.shortObj.list = orgList;
                return;
            }

            // 使用filter进行高效过滤，使用indexOf替代includes
            const filteredList = orgList.filter(item =>
                item.orgName.indexOf(selectCurrentOrgName) > -1 ||
                (item.saleCreditCode && item.saleCreditCode.indexOf(selectCurrentOrgName) > -1)
            );

            // 处理空结果情况
            $scope.shortObj.list = filteredList.length > 0
                ? filteredList
                : [{ orgName: '无匹配数据', saleCreditCode: '无匹配数据' }];
        }
        $scope.closeHandle = function () {
            $scope.topbarNav1Exception = false
        }
        window.checkSoapBeforeTaxCore = checkSoapBeforeTaxCore



        // 手工操作方案设置
        $scope.manualsolutionModal = function () {
            $uibModal
                .open({
                    template: manualsolutionModal,
                    openedClass: 'mod-modal mod-modal-hg',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        '$timeout',
                        'diskConfig',
                        'httpRequest',
                        function ($scope, $uibModalInstance, $timeout, diskConfig, httpRequest) {

                            httpRequest.get_getUserCustomized(1000).then(res => {
                                console.log(res.data.value)
                                if (res.data.value) {
                                    $scope.manualTag = res.data.value
                                } else {
                                    $scope.manualTag = '0'
                                }
                            })

                            $scope.ok = function () {
                                utils.loading('请求已发送')
                                httpRequest.post_saveUserCustomized({
                                    profileInfo: JSON.stringify(
                                         Number($scope.manualTag) ),
                                    profileType: '1000',
                                }).then(res => {
                                    utils.loaded()
                                    logger.logSuccess('保存成功')
                                    $uibModalInstance.close()

                                })

                            }
                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel')
                            }
                        },
                    ],
                    animation: true,
                    resolve: {
                        diskConfig() {
                            return {

                            }
                        },
                    },
                })
                .result.then((obj) => {
                })
        }
    }
}
mainCtrl.$inject = ['$rootScope', '$location', '$scope', 'sweetalert', 'logger', 'httpRequest', '$state', 'authService', 'removeSessionService', 'operationService', '$timeout', '$uibModal', '$http', 'collectionExportService', 'messageService']
export default mainCtrl



// WEBPACK FOOTER //
// ./src/app/mainCtrl.js